var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgClose = function SvgClose(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DAE8B7E6-B01A-441F-963B-C6418F69FBC2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DS_Suez_PCE_Atoms",
    transform: "translate(-394.000000, -542.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets-/-Icons-/-Bold-/-close",
    transform: "translate(394.000000, 542.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3,12.179 C14.2529791,12.1320979 14.2265531,12.0684136 14.2265531,12.002 C14.2265531,11.9355864 14.2529791,11.8719021 14.3,11.825 L23.563,2.563 C24.148698,1.97647359 24.1480264,1.02619799 23.5615,0.440500022 C22.9749736,-0.145197946 22.024698,-0.144526383 21.439,0.442 L12.177,9.7 C12.1300979,9.74702085 12.0664136,9.77344689 12,9.77344689 C11.9335864,9.77344689 11.8699021,9.74702085 11.823,9.7 L2.561,0.442 C1.97530202,-0.14397412 1.02547412,-0.144197977 0.4395,0.4415 C-0.14647412,1.02719798 -0.146697977,1.97702588 0.439,2.563 L9.7,11.825 C9.74702085,11.8719021 9.77344689,11.9355864 9.77344689,12.002 C9.77344689,12.0684136 9.74702085,12.1320979 9.7,12.179 L0.439,21.442 C0.0601198419,21.8210588 -0.0877544041,22.3734537 0.0510800593,22.891103 C0.189914523,23.4087522 0.594365438,23.8130125 1.11208006,23.951603 C1.62979468,24.0901934 2.18211984,23.9420588 2.561,23.563 L11.823,14.3 C11.8699021,14.2529791 11.9335864,14.2265531 12,14.2265531 C12.0664136,14.2265531 12.1300979,14.2529791 12.177,14.3 L21.439,23.563 C22.024698,24.1489741 22.9745259,24.149198 23.5605,23.5635 C24.1464741,22.977802 24.146698,22.0279741 23.561,21.442 L14.3,12.179 Z",
    id: "icon-fill-color"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close.367ad602041b77b1bbdfa0ac5ba4e74b.svg";